module.exports = __webpack_public_path__ + "static/media/19.3c467e00.jpg";